export interface RouteConfig {
  path: string;
  requiredPermissions: readonly string[];
}

/**
 * Application route configuration with permission requirements.
 * Routes are filtered at runtime based on user permissions.
 */
export const protectedRoutes = [
  // User routes - require viewing own claims
  {
    path: '/dashboard',
    requiredPermissions: ['dashboard.view.own'],
  },
  {
    path: '/profile',
    requiredPermissions: ['users.view.own'],
  },
  {
    path: '/faq',
    requiredPermissions: ['dashboard.view.own'],
  },
  {
    path: '/categories',
    requiredPermissions: ['dashboard.view.own'],
  },
  {
    path: '/claims',
    requiredPermissions: ['claims.view.own'],
  },

  // Admin routes - require specific admin permissions
  {
    path: '/admin/dashboard',
    requiredPermissions: ['users.view.all'],
  },
  {
    path: '/admin/claims',
    requiredPermissions: ['claims.view.all', 'claims.approve.all', 'claims.reject.all'],
  },
  {
    path: '/admin/export',
    requiredPermissions: ['claims.view.all'],
  },
  {
    path: '/admin/users',
    requiredPermissions: ['users.view.all'],
  },
  {
    path: '/admin/users/:userId',
    requiredPermissions: ['users.view.all'],
  },
] as const satisfies readonly RouteConfig[];

export type ProtectedPath = (typeof protectedRoutes)[number]['path'];
